import { memoize } from 'lodash-es';

/**
 * memoize by default caches based on the first argument. This
 * makes it actually cache based on all arguments.
 */
function memoizeMultiArg<A extends Array<string | undefined | number | boolean | null>, R>(
    func: (...args: A) => R
): (...args: A) => R {
    return memoize(func, (...args) => args.join('_'));
}

export default memoizeMultiArg;
